package com.patronat.top.client.presentation.home.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.patronat.top.client.presentation.home.model.HomeCategoryShortcut
import com.patronat.top.client.presentation.home.model.homeCategoryShortcuts
import com.patronat.top.client.presentation.home.model.icon
import com.patronat.top.dto.venues.VenueGroup
import com.patronat.top.ui.theme.BodyMedium
import com.patronat.top.ui.theme.MineShaft50
import com.patronat.top.ui.theme.MineShaft500
import com.patronat.top.ui.theme.MineShaft900
import com.patronat.top.ui.theme.MineShaft950
import com.patronat.top.ui.theme.VenueSectionTitleText
import org.jetbrains.compose.resources.stringResource
import top.clientapp.generated.resources.Res
import top.clientapp.generated.resources.client_home_categories
import top.clientapp.generated.resources.client_home_view_all

@Composable
fun HomeCategorySection(
    selectedGroup: VenueGroup?,
    onCategoryClick: (HomeCategoryShortcut) -> Unit,
    onViewAllClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    val categoryItems = homeCategoryShortcuts()

    Column(modifier = modifier) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                text = stringResource(Res.string.client_home_categories),
                style = VenueSectionTitleText.copy(
                    color = MineShaft900,
                    fontSize = 20.sp,
                    lineHeight = 30.sp,
                    letterSpacing = (-0.45).sp,
                    fontWeight = FontWeight.Medium
                )
            )

            Text(
                text = stringResource(Res.string.client_home_view_all),
                style = BodyMedium.copy(
                    color = MineShaft500,
                    fontSize = 16.sp,
                    lineHeight = 24.sp,
                    letterSpacing = (-0.31).sp,
                    fontWeight = FontWeight.Medium
                ),
                modifier = Modifier.clickable(onClick = onViewAllClick)
            )
        }

        Spacer(modifier = Modifier.height(14.dp))

        LazyRow(
            horizontalArrangement = Arrangement.spacedBy(14.dp),
            modifier = Modifier.fillMaxWidth()
        ) {
            items(
                items = categoryItems,
                key = { it.id }
            ) { category ->
                HomeCategoryItem(
                    category = category,
                    selected = selectedGroup == category.group,
                    onClick = { onCategoryClick(category) }
                )
            }
        }
    }
}

@Composable
private fun HomeCategoryItem(
    category: HomeCategoryShortcut,
    selected: Boolean,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    Column(
        modifier = modifier
            .width(56.dp)
            .height(84.dp)
            .clickable(onClick = onClick),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Box(
            modifier = Modifier
                .size(56.dp)
                .clip(RoundedCornerShape(12.dp))
                .background(if (selected) MineShaft950 else CategoryBackground),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                painter = category.group.icon(),
                contentDescription = null,
                tint = if (selected) MineShaft50 else Color.Unspecified,
                modifier = Modifier.size(30.dp)
            )
        }

        Spacer(modifier = Modifier.height(8.dp))

        Text(
            text = stringResource(category.labelRes),
            style = BodyMedium.copy(
                color = CategoryLabelColor,
                fontSize = 13.sp,
                lineHeight = 19.5.sp,
                letterSpacing = (-0.08).sp,
                fontWeight = FontWeight.Normal,
                textAlign = TextAlign.Center
            ),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
    }
}

private val CategoryBackground = Color(0xFFF6F6F6)
private val CategoryLabelColor = Color(0xFF454545)
